import { FormattedReport } from "../../Shared/Report";

const department = "promo";
const reports = [
  { access: "availableSpaces", title: "Available Options" },
  { access: "prospectiveInvestors", title: "Prospective Investors" },
  ///////
  // changes added
  { access: "potentialInvestors", title: "Potential Investors" },
  
  //////
  { access: "activeContracts", title: "Active Contract Agreements" },
  { access: "adminReport", title: "Summary Report" },
  { access: "referenceByTime", title: "References by Time" }, //const {startDate,endDate}=req.params
  { access: "requestProgress", title: "Progress of References" },
  { access: "referredDetail", title: "Detailed References" },
];
export default function EICReports() {
  return <FormattedReport reports={reports} department={department} />;
}
